export enum ProductNutritionElementUom {
  OZ = 'OZ',
  G = 'G',
  MG = 'MG',
  MCG = 'MCG'
}
